import { useUserStore } from './user-store';
import { InitialUser } from './user-types';
import useUserRepository from './modules/use-user-repository';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export default function useUser() {
  const { checkLogin } = useUserRepository();
  const userStore = useUserStore();
  const { fetchUser } = useUserRepository();

  const getUser = (): InitialUser => {
    const userStore = useUserStore();
    return userStore.user;
  };

  const isUserLoggedIn = async (): Promise<boolean> => {
    return await checkLogin()
      .then(() => true)
      .catch(() => false);
  };

  const loadProfile = async (userId: number): Promise<void> => {
    if (!userStore.profileUser) {
      return;
    }

    const user = await fetchUser(userId);
    userStore.setProfileUser(user);
  };

  const reloadCurrentProfile = async (): Promise<void> => {
    if (!userStore.profileUser) {
      return;
    }

    const user = await fetchUser(userStore.profileUser.user.id);
    userStore.setProfileUser(user);
  };

  return {
    loadProfile,
    reloadCurrentProfile,
    isUserLoggedIn,
    getUser,
  };
}
